import { render, staticRenderFns } from "./FormBanner.vue?vue&type=template&id=2afe522b&"
import script from "./FormBanner.vue?vue&type=script&lang=js&"
export * from "./FormBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports